import axios from 'axios';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CamDigiKeyContext } from '../hooks/useCamDigiKey';
import { ErrorAlert } from './QrCodeLoginView';

export default function ConsentLoginView({ setDataAfterLogout }) {
  const [loading, setLoading] = React.useState(false)
  const [loadingMessage, setLoadingMessage] = React.useState('')
  const [error, setError] = React.useState(null)
  const { t, i18n } = useTranslation()
  const { data, loginToken } = React.useContext(CamDigiKeyContext)

  const requestConsent = async (isCancel = false) => {
    try {
      const res = await axios.post("/api/v1/authenticate/requestConsent", {
        loginToken,
        action: isCancel ? 'BTN_CANCEL' : 'BTN_CONTINUE'
      })
      console.log("consent isCancel", isCancel, "res", res.data)
      if (res.data?.error === 0) {
        const redirectUrl = res.data?.data?.redirectUrl
        window?.location?.replace(redirectUrl)
      } else if (res.data?.error === 4000) {
        setLoading(false)
        setError({
          message: 'error.invalid_login_token',
          description: 'error.invalid_login_token_description'
        })
      } else if (res.data?.error === 4002) {
        setLoading(false)
        setError({
          message: 'error.login_token_expired',
          description: 'error.login_token_expired_description'
        })
      } else {
        setLoading(false)
        setError({
          message: 'error.unknown',
          description: 'error.unknown_description',
        })
      }
    } catch (err) {
      setLoading(false)
      setError({
        message: 'error.something_went_wrong',
        description: 'error.something_went_wrong_description'
      })
    }
  }

  const consentLoginRequest = async () => {
    setLoadingMessage('app.authorizing_login_request')
    setLoading(true)
    await requestConsent()
  }

  const cancelLoginRequest = async () => {
    setLoadingMessage('app.cancelling_login_request')
    setLoading(true)
    await requestConsent(true)
  }

  const logout = async () => {
    setLoadingMessage('app.logging_out')
    setLoading(true)
    try {
      const res = await axios.post("/api/v1/authenticate/requestLogout", {
        loginToken
      })
      setLoading(false)

      console.log("logout res =>", res.data)
      if (res.data?.error === 0) {
        setDataAfterLogout(res.data.data)
      } else {
        setLoading(false)
        setError({
          message: 'error.unknown',
          description: 'error.unknown_description',
        })
      }
    } catch (err) {
      setLoading(false)
      setError({
        message: 'error.something_went_wrong',
        description: 'error.something_went_wrong_description'
      })
    }
  }

  return (
    <div className='flex-col items-center'>
      <div className="flex justify-center mb-6">
        <div className=" mr-3 md:block" style={{ width: '90px' }}>
          <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
            <g data-name="Group 121" id="Group_121" transform="translate(89.025 1045.901)">
              <path d="M50.785-1023.592a58.053,58.053,0,0,0-24.21,8.106A56.065,56.065,0,0,0,.291-972.58c-.355,4.285-.355,172.579,0,176.864A57.637,57.637,0,0,0,5.559-776.2a55.921,55.921,0,0,0,45.772,31.524c4.285.355,172.579.355,176.864,0A55.921,55.921,0,0,0,273.966-776.2a57.636,57.636,0,0,0,5.268-19.515c.355-4.285.355-172.579,0-176.864a55.921,55.921,0,0,0-31.524-45.772,57.635,57.635,0,0,0-19.515-5.268C224.319-1023.947,54.579-1023.919,50.785-1023.592Zm104.126,21.262a12.048,12.048,0,0,1,9.962,10.235c.164,1.228.273,17.686.273,45.471v43.561l2.129.873a71.431,71.431,0,0,1,41.678,49.7,57.929,57.929,0,0,1,1.61,15.694,56.655,56.655,0,0,1-1.638,15.639,70.645,70.645,0,0,1-26.42,40.968,74.034,74.034,0,0,1-25.329,12.2,71.012,71.012,0,0,1-67.5-18.587A70.741,70.741,0,0,1,70.573-852.35c1.747-7.751,5.513-16.977,8.789-21.508a12.126,12.126,0,0,1,14.275-3.576,11.655,11.655,0,0,1,5.6,5.377c2.129,4.34,1.938,7.287-.846,12.61A47.6,47.6,0,0,0,94.1-848.529a37.9,37.9,0,0,0-1.392,12.146,33.315,33.315,0,0,0,.737,8.761c3.985,19.024,17.9,32.944,37.01,37.038,3.139.655,3.958.71,9.444.71,5.213,0,6.387-.082,8.87-.6a50.138,50.138,0,0,0,17.632-7.451,52.649,52.649,0,0,0,12.364-12.364,47.184,47.184,0,0,0,.191-52.7,46.834,46.834,0,0,0-27.185-19.379c-3.548-.928-5.131-1.719-6.987-3.466a10.919,10.919,0,0,1-3.221-5.1c-.382-1.337-.437-6.359-.437-51.64V-992.75l.628-1.747a12.006,12.006,0,0,1,9.225-7.806A8.324,8.324,0,0,1,154.911-1002.33Zm-38.539,12.419a14.853,14.853,0,0,1,10.235,21.044,15.469,15.469,0,0,1-8.625,7.533,16.954,16.954,0,0,1-9.334,0,14.8,14.8,0,0,1-10.017-14.93A14.685,14.685,0,0,1,116.372-989.911Zm1.965,37.474a16.112,16.112,0,0,1,5.868,3.93,14.774,14.774,0,0,1,1.692,17.85,14.155,14.155,0,0,1-11.682,6.878,13.837,13.837,0,0,1-11.272-4.258c-8-8.079-4.722-21.016,6.25-24.674A18.6,18.6,0,0,1,118.337-952.437Zm25.793,91.789c8.652,1.365,16.049,7.943,19,16.895.737,2.183.764,2.593.764,7.1s-.027,4.913-.764,7.1a24.759,24.759,0,0,1-10.071,13.319,23.481,23.481,0,0,1-13.292,3.876,23.481,23.481,0,0,1-13.292-3.876A24.759,24.759,0,0,1,116.4-829.56c-.737-2.183-.764-2.593-.764-7.1s.027-4.913.764-7.1a24.613,24.613,0,0,1,15.339-15.94A24.654,24.654,0,0,1,144.13-860.648Z" data-name="Path 268" fill="#2e5ae1" id="Path_268" stroke="#707070" strokeWidth="0.1" transform="translate(-89 -22)" />
            </g>
          </svg>
        </div>
        <div>
          <h1 className="leading-tight font-bold text-gray-700 text-2xl md:text-2xl xl:text-4xl">{t('app.title')}</h1>
          <p className="text-gray-500 mt-2 mb-8 text-base md:text-lg xl:text-xl">{t('app.sub_title')}</p>
        </div>
      </div>

      <div className='flex justify-center'>
      <div className="w-full max-w-sm">
        <div className="rounded-lg border border-gray-100 py-6 px-4 shadow-2xl bg-white ">
          <div className='flex justify-center'>
            <img draggable={false} alt="google.com" title="google.com" className='aspect-square object-cover w-14 h-14 rounded-md' src={`data:image/png;base64,${data?.clientLogo}`} />
          </div>
          
          <h3 className="text-lg font-semibold text-center text-gray-800 mt-3">
            { i18n.language === 'en' ? data?.clientNameEn : data?.clientNameKh} {" "}
            <span className='font-normal text-lg mb-9 mt-1 text-gray-500'>
              {t('app.access_message.first')}
              <a className="font-normal hover:underline hover:cursor-pointer text-blue-400" href={data?.clientPrivacyPolicyURL} rel="noopener noreferrer" target="_blank">
                {t('app.access_message.second')}
              </a>
              {t('app.access_message.third')}
            </span>
          </h3>

          <p className="text-gray-500 text-center my-8">
            {t('app.information_sharing_info')}
          </p>

          <div className="flex flex-col gap-4 pb-3">
            <button onClick={consentLoginRequest} className="p-2 rounded-lg text-white bg-blue-600 hover:bg-blue-700 shadow-md shadow-bg-blue-500">
              {t('app.button.continue_as')}{' '}<strong>{ data?.name }</strong>
            </button>
            <button onClick={cancelLoginRequest} className="p-2 rounded-lg text-gray-600 bg-gray-100 hover:text-gray-700 hover:bg-gray-200">
              {t('app.button.cancel')}
            </button>
            <button onClick={logout} className="p-2 rounded-lg text-red-600 bg-gray-100 hover:text-red-700 hover:bg-gray-200">
              {t('app.button.logout')}
            </button>
          </div>

          <p className="w-full mt-4 text-sm text-center text-gray-400">
            <span dangerouslySetInnerHTML={{__html: t('app.aggreement')}} />
          </p>

          { loading
            ? <div className="fixed inset-0 bg-gray-500 bg-opacity-70 overflow-y-auto h-full w-full flex justify-center items-center" id="loading" style={{ zIndex: 99999 }}>
                <div className="relative mx-2 p-5 border w-96 shadow-lg rounded-md bg-white bg-opacity-70">
                  <div className="mt-3 text-center">
                    <div className="animate-spin rounded-full h-20 w-20 border-b-2 border-gray-900 mx-auto"></div>
                    <p className="my-5 text-sm text-gray-500">
                      <span>{t(loadingMessage)}</span>
                    </p>
                  </div>
                </div>
              </div>
            : null
          }

          { error ? <ErrorAlert error={error} /> : null }
        </div>
      </div>
      </div>
    </div>
  );
}